export default __webpack_public_path__ + "static/media/search-user-white.0384c4c0.svg";